'use client';

import { Card } from '@chakra-ui/react';
import type { CardRootProps } from '@chakra-ui/react';

import { Form } from '@packages/hook-form-wrapper';

type JobSearchCheckboxFilterProps = {
	columns?: number
	items:    { label: string; name: string }[]
	title:    string
} & CardRootProps;

export const JobSearchCheckboxFilter = ({
	columns = 2,
	items,
	title,
	...props
}: JobSearchCheckboxFilterProps) => {
	const gridCols = `repeat(${columns}, 1fr)`;

	return (
		<Card.Root
			border="1px solid"
			borderColor="gray.15"
			maxW="4xl"
			overflow="hidden"
			{...props}
		>
			<Card.Header
				borderBottom="1px solid"
				borderBottomColor="gray.15"
				px={4}
				py={2}
			>
				<Card.Title textStyle="bodyBold">
					{title}
				</Card.Title>
			</Card.Header>

			<Card.Body
				css={{
					[`& > *:nth-of-type(-n+${columns})`]: { borderTop: 'none' },
					[`& > *:nth-of-type(${columns}n+1)`]: { borderLeft: 'none' },

					'& > *': {
						borderLeft:      '1px solid',
						borderLeftColor: 'gray.15',
						borderTop:       '1px solid',
						borderTopColor:  'gray.15',
						px:              4,
						py:              2,
					},
				}}
				display="grid"
				gridTemplateColumns={gridCols}
				p={0}
			>
				{items.map(opt => (
					<div key={opt.name}>
						<Form.Checkbox gap={4} name={opt.name}>
							{opt.label}
						</Form.Checkbox>
					</div>
				))}
				{items.length % 2 !== 0 && columns > 1 && (
					<div />
				)}
			</Card.Body>
		</Card.Root>
	);
};
